
import Vue from 'vue'

const getDefaultState = () => {
    return {
        vehicle: {
            id: 0,
            idServiceProject: 0,
            idProduct: 0,
        }
    }
};

const state = getDefaultState();

const actions = {

    resetState({ commit }) {
        commit('resetState');
    },

    saveState({ commit }, payload) {
        commit('saveState', payload);
    },

    async ListByUser(_, idUser) {

        try {
            const result = await Vue.prototype.$vanKirkApi.get(`hr/vehicle/list-by-user/${idUser}`,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.data) {
                const listVehicle = result.data.result;

                return listVehicle;
            }
            else {
                return [];
            }
        }
        catch(ex) {
            return {
                success: false,
                message: `Error to list vehicle: [${ex}]`
            };
        }
    },

    async GetById(_, id) {

        try {
            const result = await Vue.prototype.$vanKirkApi.get(`hr/vehicle/${id}`,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 200) {
                return result.data;
            }
            else {
                return {
                    success: false,
                    result: `Error to get vehicle`
                };
            }
        }
        catch(ex) {
            return {
                success: false,
                result: `Error to get vehicle: [${ex}]`
            };
        }
    },

    async CreateUpdate(_, vehicleRequest) {

        try {

            const result = await Vue.prototype.$vanKirkApi.post(`hr/vehicle/create-update`, vehicleRequest,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 200) {

                let msg = "Register updated with success!";

                if (vehicleRequest.id === 0) {
                    msg = "Record created successfully";
                }

                return {
                    success: true,
                    idVehicle: result.data.result,
                    message: msg
                };
            }
            else {
                return {
                    success: false,
                    message: "Error to create/update register!"
                };
            }
        }
        catch(error) {

            if (error.response && error.response.status === 400) {
                return {
                    success: false,
                    message: `Error to create/update register: [${error.response.data}]`
                };
            }
            else {

                return {
                    success: false,
                    message: `Error to create/update register: [${error}]`
                };
            }
        }
    },

    async UpdateStatus(_, vehicleStatusRequest) {

        try {
            const result = await Vue.prototype.$vanKirkApi.put(`hr/vehicle/update-status/${vehicleStatusRequest.id}`, vehicleStatusRequest,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 204) {
                return {
                    success: true,
                    message: "Status updated with success!"
                };
            }
            else {
                return {
                    success: false,
                    message: "Error updating the status!"
                };
            }
        }
        catch(ex) {
            return {
                success: false,
                message: `Error updating the status: [${ex}]`
            };
        }
    },
}

const mutations = {

    saveState: (state, newValue) => {
        Object.assign(state.vehicle, newValue);
    },

    resetState: (state) => {
        Object.assign(state, getDefaultState());
    }
}

const getters = {

    searchState: (state) => {
        return state.vehicle;
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}